import styled from 'styled-components';

export const ControlFieldLabel = styled.div`
  margin: 15px 0 5px 0;
  color: var(--foreground);
  font-weight: var(--font-weight-medium);
  font-size: var(--text-xs);
  line-height: 140%;
`;
